<template>
  <q-card flat class="admin-tab">
    <q-card-section class="bg-white fit tables-wrapper">
      <CredentialsTable />
      <MasterArticleDataSourcesTable />
    </q-card-section>
  </q-card>
</template>

<script>
import CredentialsTable from './components/CredentialsTable'
import MasterArticleDataSourcesTable from './components/MasterArticleDataSourcesTable'

export default {
  components: {
    CredentialsTable,
    MasterArticleDataSourcesTable
  }
}
</script>

<style lang="stylus" scoped>
>>> .q-table__container {
  padding 10px 5px
}
>>> .q-table {
  th {
    height unset
    padding 7px 16px
  }
}

.admin-tab {
  padding 20px
  background #E6E6E6

  .tables-wrapper {
    display grid
    align-content start
    gap 15px
  }
}
</style>
